import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_n77n5vays8: FaireBrandEntity = {
  token: "b_n77n5vays8",
  type: "brand",
  name: "kycozy",
  avatarUrl:
    "https://cdn.faire.com/fastly/cc3ee5e9a68c12e64c98c57723c0e7d5d13c52925bb6548c9fdbe011203c3930.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/812d819a438b5840eaab6e5946cd326082a8400fa950aec8bffd07ae3982a854.png",
  logoUrl:
    "https://cdn.faire.com/fastly/cc3ee5e9a68c12e64c98c57723c0e7d5d13c52925bb6548c9fdbe011203c3930.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/812d819a438b5840eaab6e5946cd326082a8400fa950aec8bffd07ae3982a854.png",
  location: "Richmond, TX, USA",
  minimumOrderDollars: 130,
  rating: 3.5,
  reviewCount: 37,
  isInsider: false,
  description:
    "Founded in 2024 by two college best friends, Kycozy started as a tiny online shop in a spare bedroom at Morgan's house. From hosting pop-up events at local universities to packing orders late into the night (while juggling full-time jobs), we poured our passion and perseverance into growing that little web store into what it is today—a fashion brand with 12 brick-and-mortar locations across the Southeast, while our e-commerce site remains at the heart of everything we do.\n\nToday, Kycozy is run by a close-knit team of 5 full-time and 5 part-time women, all dedicated to bringing you a unique and fun shopping experience. Follow along as we share styling inspiration, behind-the-scenes moments, and glimpses into our team’s journey.\n\nEvery bit of your support and feedback means the world to us. Thank you for being an essential part of Kycozy’s story.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:14.738Z",
    importedBy: "entity-db-cli",
  },
};
